import { createSignal, type Accessor } from 'solid-js';

export interface FeatureExtractionTileCache {
  readonly tileCacheToken: Accessor<string>;
  bumpTileCacheToken(): void;
}

// Guards against same-millisecond bumps producing an unchanged token.
let tileCacheTokenSequence = 0;

function nextTileCacheToken(): string {
  tileCacheTokenSequence += 1;
  return `${new Date().toISOString().slice(0, -1)}-${tileCacheTokenSequence}`;
}

export function createTileCache(): FeatureExtractionTileCache {
  const [tileCacheToken, setTileCacheToken] =
    createSignal(nextTileCacheToken());
  const bumpTileCacheToken = (): void => {
    setTileCacheToken(nextTileCacheToken());
  };
  return { tileCacheToken, bumpTileCacheToken };
}
